/**
 * Model for Document search.
 */
export class DocumentSearch {
    name: string;
    content: string;
    entityId: number;
    validFrom: Date;
    validTo: Date;
    typeId: number;
    labelId: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/document.search.ts